<input  #inputFile [accept]="accept" [disabled]="disabled" type="file" (change)="onFileSelect($event.target.files)" hidden/>
<input type="input" hidden required/>
<a (click)="inputFile.click()">
    <ng-content></ng-content>
</a>
